import { createApp } from 'vue/dist/vue.esm-bundler';
import People from './People.vue';


const mountEl = document.querySelector('[data-app-people]');

if ( mountEl )
{
    createApp(People, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}